module.exports = __webpack_public_path__ + "img/taco-yellow.bb674c3a.png";